import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { API_INTERACT_URL, axiosInt } from '../utils';
import type { IPublicTranslation } from './types';

export const FETCH_PUBLIC_TRANSLATIONS_KEY = 'public-translations';

export const usePublicTranslations = (
  options?: Omit<UseQueryOptions<IPublicTranslation[]>, 'queryKey' | 'queryFn'>
) => {
  const { data = [], isLoading } = useQuery<IPublicTranslation[]>({
    ...options,
    queryKey: [FETCH_PUBLIC_TRANSLATIONS_KEY],
    queryFn: () =>
      axiosInt
        .get<IPublicTranslation[]>(`${API_INTERACT_URL}/public/translations`)
        .then(r => r.data),
    staleTime: 5 * 60 * 1000,
  });

  return { data, isLoading };
};
